An array of `Location` identifiers.

Scheme requirements:

- This field currently requires a single identifier for a location.
